/*
 * This is a mixin used by OptimizerInputOberserver.vue
 *
 */

import { mapGetters } from 'vuex' /*, mapActions*/
import TaskManagementMixin from "@/components/Mixins/TaskManagement"

export default {
  mixins: [ TaskManagementMixin ],
  created() {

  },
  computed: {
    ...mapGetters("dayplanner", [
      'dayplanner_unfinished_tasks_old'
    ]),
  },
  watch: {
    "dayplanner_unfinished_tasks_old": {
      handler( dayplanner_unfinished_tasks_old ) {
        //console.log('dayplanner_unfinished_tasks_old', dayplanner_unfinished_tasks_old)

        dayplanner_unfinished_tasks_old.forEach(item => {
          //console.log('dayplanner_unfinished_tasks_old item', item)
          let task = this.$models.taskMeta.with({
            goalId: item.$state.goalId,
            uid: item.$state.assignedUserId
          })
          .subscribeNode(item.$state.taskId)
          task.$promise.then(() => {
            //console.log('dayplanner_unfinished_tasks_old task loaded', task, 'sessionId:', item.sessionId)
            if (task) {
              if (task.done) {

                let session = this.$models.userDayplannerSessions
                .subscribeNode(item.$sessionId)
                session.$promise.then(() => {
                  if (session) {
                    this.onRemoveTaskFromSession(task, session)
                  }
                })
              }
            } else { // tasks does not exist here any more
              // TODO: delete task from session
            }
          })
        })

      }
    },
  },
  methods: {
  }
}
